import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { LogOut, Briefcase, Bookmark, CreditCard, Trophy, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth-context";
import { api } from "@/lib/auth-context";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_attorney-ready/artifacts/06pkbseh_lexintake%20logo.png";

export default function AttorneyLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const handlePortal = async () => {
    try {
      const { data } = await api.post("/billing/portal", {
        origin_url: window.location.origin,
      });
      if (data.portal_url) window.location.href = data.portal_url;
    } catch (e) {
      console.warn("Billing portal unavailable", e);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col">
      <header
        data-testid="attorney-header"
        className="sticky top-0 z-30 bg-white border-b border-slate-200"
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-8">
            <img src={LOGO_URL} alt="LexIntake" className="h-12 w-auto object-contain" />
            <nav className="hidden md:flex gap-6">
              <NavLink
                to="/attorney/dashboard"
                end
                data-testid="nav-attorney-dashboard"
                className={({ isActive }) =>
                  `text-sm font-medium flex items-center gap-1.5 ${
                    isActive ? "text-[#0A192F]" : "text-slate-500 hover:text-[#0A192F]"
                  }`
                }
              >
                <Briefcase className="w-4 h-4" /> All cases
              </NavLink>
              <NavLink
                to="/attorney/dashboard?tab=claimed"
                data-testid="nav-attorney-claimed"
                className="text-sm font-medium flex items-center gap-1.5 text-slate-500 hover:text-[#0A192F]"
              >
                <Trophy className="w-4 h-4" /> Claimed
              </NavLink>
              <NavLink
                to="/attorney/dashboard?tab=saved"
                data-testid="nav-attorney-saved"
                className="text-sm font-medium flex items-center gap-1.5 text-slate-500 hover:text-[#0A192F]"
              >
                <Bookmark className="w-4 h-4" /> Saved
              </NavLink>
              <NavLink
                to="/attorney/territory"
                data-testid="nav-attorney-territory"
                className="text-sm font-medium flex items-center gap-1.5 text-slate-500 hover:text-[#0A192F]"
              >
                <MapPin className="w-4 h-4" /> Territory
              </NavLink>
            </nav>
          </div>
          <div className="flex items-center gap-3">
            <div className="hidden sm:block text-right">
              <p className="text-sm font-medium text-[#0A192F]">{user?.name}</p>
              <p className="text-xs text-slate-500">
                {user?.subscription_plan
                  ? `${user.subscription_plan} plan`
                  : "Subscriber"}
              </p>
            </div>
            {(
              <Button
                variant="ghost"
                size="sm"
                data-testid="attorney-portal-btn"
                onClick={handlePortal}
                className="text-slate-700"
              >
                <CreditCard className="w-4 h-4 mr-2" /> Billing
              </Button>
            )}
            <Button
              variant="ghost"
              size="sm"
              data-testid="attorney-logout-btn"
              onClick={handleLogout}
              className="text-slate-700"
            >
              <LogOut className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </header>
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}
